import React, { useEffect } from 'react';
import { Select, Form } from '@whalecloud/fdx';
import { i18n } from 'fishx';

import { get } from 'lodash';
import styles from '../index.module.less';

const DefaultPricePlan = props => {
  const {onDppChange, currentDpp, dppOfferList = [], form} = props;
  const {getFieldDecorator, setFieldsValue} = form;

  useEffect(() => {
    // 改变原有结构, 直接从父级取当前选中值, 不然存在逻辑重复, 因为已经在父级计算过一次初始选择了
    // const selectDpp = dppOfferList.find(dpp => dpp.defaultFlag === 'Y')?.offerDto?.offerId || get(dppOfferList[0], 'offerDto.offerId');
    setFieldsValue({ selectDpp: currentDpp.offerId });
  }, [currentDpp]);

  const changeDpp = value => {
    onDppChange(get(dppOfferList.find(dpp => get(dpp, 'offerDto.offerId') === value), 'offerDto') || {});
  };

  return (
    <div className={`blockWrap ${styles.offerGroupDiv}`}>
      <div className={styles.header}>
        <h3 className="blockTitle">{i18n('SELECT_DEFAULT_PRICE_PLAN')}</h3>
      </div>
      {getFieldDecorator('selectDpp')(
        <Select className={styles.selectBox}
                onChange={changeDpp}>
          {dppOfferList.map(dpp =>
            <Select.Option value={get(dpp, 'offerDto.offerId')}
                           key={get(dpp, 'offerDto.offerId')}>{get(dpp, 'offerDto.offerName')}</Select.Option>
          )}
        </Select>)
      }
    </div>
  );
};

export default Form.create()(DefaultPricePlan);
